var _defs, _g, _g2, _polygon, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarshipNix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d6d6d6;\n      }\n\n      .cls-2 {\n        fill: #e2e2e2;\n      }\n\n      .cls-3 {\n        fill: #fff;\n        opacity: .15;\n      }\n\n      .cls-4 {\n        fill: #1e1e1e;\n      }\n\n      .cls-5 {\n        fill: #aaa;\n      }\n\n      .cls-6 {\n        fill: #a10ba6;\n      }\n\n      .cls-7 {\n        fill: #565656;\n      }\n\n      .cls-8 {\n        fill: #878787;\n      }\n\n      .cls-9 {\n        fill: #2ccfdb;\n      }\n\n      .cls-10 {\n        fill: #b50cba;\n      }\n\n      .cls-11 {\n        fill: #29e6ff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "444.78 365.84 302.78 365.84 322.78 363.84 424.78 363.84 444.78 365.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "444.78 365.84 302.78 365.84 322.78 367.84 424.78 367.84 444.78 365.84"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "350.25 335 370.73 363.02 538.86 363.02 350.25 335"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "538.86 363.02 370.73 363.02 363.18 373.8 538.86 363.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "260.13 380.26 232.86 373.22 232.86 340.21 260.13 333.17 260.13 380.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "370.73 363.02 253.31 363.02 237.86 319.91 350.25 335 370.73 363.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "215.7 281.58 237.95 320.19 408.45 343.62 352 310.91 215.7 281.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.18 373.8 327.61 375.95 271.57 374.87 253.25 363.02 370.73 363.02 363.18 373.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "375.76 387.91 289.09 392.12 289.09 380.9 375.76 385.07 375.76 387.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "317.91 405.92 250.4 406.31 253.26 363.02 316.84 363.02 317.91 405.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "317.16 373.59 251.06 384.21 253.26 363.02 316.84 363.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "341.52 415.61 376.07 402.21 216.09 402.21 243.93 425.45"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "367.95 320.19 223.95 295.19 215.95 281.19 351.95 311.19 367.95 320.19"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "363.95 406.19 225.95 409.19 215.65 402.08 375.95 402.19 363.95 406.19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarshipNix);
export default __webpack_public_path__ + "static/media/starship-nix.4e86d7fbe5f1b90f1b50eaebb799e67d.svg";
export { ForwardRef as ReactComponent };